import {ClientAttachmentsService} from '../../libs/ui/src/index';
import {client} from '../apiService';
const _ClientAttachmentsService = new ClientAttachmentsService({client});
export {_ClientAttachmentsService as ClientAttachmentsService};
